var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useState, useRef } from "react";
import styled from "styled-components";
import { useDialogContainer } from "core/Dialog";
import ClickToOpen from "./ClickToOpen";
import HoverToOpen from "./HoverToOpen";
import Title from "./Title";
import { TooltipContainer, tooltipThemeStyles } from "./styles";
import { MuiThemeProvider } from "js/helpers/materialUI";
import FocusTrap from "focus-trap-react";
var UnstyledTooltip = function (_a) {
    var _b, _c;
    var _d = _a.darkMode, darkMode = _d === void 0 ? false : _d, _e = _a.size, size = _e === void 0 ? "large" : _e, _f = _a.clickToOpen, clickToOpen = _f === void 0 ? false : _f, _g = _a.interactive, interactive = _g === void 0 ? true : _g, textAlignment = _a.textAlignment, message = _a.message, children = _a.children, className = _a.className, _h = _a.leaveDelay, leaveDelay = _h === void 0 ? 100 : _h, _j = _a.placement, placement = _j === void 0 ? "bottom" : _j, _k = _a.tabIndex, tabIndex = _k === void 0 ? null : _k, _l = _a.open, open = _l === void 0 ? null : _l, _m = _a.slotProps, slotProps = _m === void 0 ? {} : _m, _o = _a.PopperProps, PopperProps = _o === void 0 ? {} : _o;
    var dialogContainer = useDialogContainer();
    var _p = useState(null), modalExists = _p[0], setModalExists = _p[1];
    var isSmallTooltip = size === "small";
    var isBrowser = typeof document !== "undefined";
    // if tooltip has interactive content, we need to add a focus trap
    // to allow keyboard navigation within the tooltip
    var trapRef = useRef(null);
    var wrappedMessage = clickToOpen && interactive && modalExists === false ? (_jsx(FocusTrap, { focusTrapOptions: {
            allowOutsideClick: true,
            // not all tooltip have tabbable content, v9 enforces tabbable content
            // adding fallbackFocus ensures that focus-trap-react v9 behaves like 8 did
            // otherwise we get the error:
            //  - Your focus-trap must have at least one container with at least one tabbable node in it at all times
            fallbackFocus: function () { return trapRef.current; },
        }, children: _jsx("div", { ref: trapRef, children: message }) })) : (message);
    var title = (_jsx(Title, { textAlignment: textAlignment, darkMode: darkMode, message: wrappedMessage, isSmallTooltip: isSmallTooltip }));
    // HACK: FocusTrap and Material-UI modals don't play well together
    // so, enable FocusTrap once we confirm no modal in the DOM
    useEffect(function () {
        if (typeof document !== "undefined") {
            var muiModal = document.querySelector(".MuiBackdrop-root");
            setModalExists(!!muiModal);
        }
    }, [isBrowser, setModalExists]);
    // When inside a Dialog, render the Popper within the dialog's DOM to avoid
    // z-index/positioning issues. Explicit PopperProps.container takes precedence.
    var mergedPopperProps = __assign(__assign({}, PopperProps), { container: (_c = (_b = PopperProps.container) !== null && _b !== void 0 ? _b : dialogContainer === null || dialogContainer === void 0 ? void 0 : dialogContainer.current) !== null && _c !== void 0 ? _c : undefined });
    var sharedProps = {
        className: className,
        arrow: true,
        interactive: interactive,
        darkMode: darkMode,
        isSmallTooltip: isSmallTooltip,
        textAlignment: textAlignment,
        placement: placement,
        leaveDelay: leaveDelay,
        title: title,
        tabIndex: tabIndex,
        slotProps: slotProps,
        PopperProps: mergedPopperProps,
    };
    return (_jsx(MuiThemeProvider, { theme: tooltipThemeStyles({ darkMode: darkMode, isSmallTooltip: isSmallTooltip }), children: _jsx(TooltipContainer, { className: className, children: clickToOpen ? (_jsx(ClickToOpen, __assign({}, sharedProps, { children: children }))) : (_jsx(HoverToOpen, __assign({}, sharedProps, { open: open, children: children }))) }) }));
};
var Tooltip = styled(UnstyledTooltip)(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
export default Tooltip;
var templateObject_1;
